<div *ngIf="content" [innerHTML]="content | MarkdownToHtml"></div>
